$(window).on('passwords:loaded', function() {
    $('#modal_login').modal({
        backdrop: 'static',
        keyboard: false
    }).modal('show');
});
